module.exports = __webpack_public_path__ + "static/media/instagram-button-icon.b99a5a47.png";